<template>
    <input ref="input" type="number" v-bind:value="value" v-on:keypress="forceNumeric" v-on:input="updateValue($event.target.value)">
</template>
<script>
export default {
    name: 'input-number',
    props: ['value'],
    methods: {
        forceNumeric(evt) 
        {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
                return false;
            }
            return true;
        },
        updateValue: function (value) {
            this.$refs.input.value = value;           
            this.$emit('input', Number(value));
        }
    }
}
</script>